// @ts-nocheck
 
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
 
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
  Alert,
 IconButton } from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  createStyles,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,

} from '@material-ui/core';
import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { TextCell } from 'app/components/shared/table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import { set } from 'lodash';
const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);
const OrgComTypTable = ({
  commission_type_id,
  isLoading,
  organisationCommissionTypes,
  hasCommissionsWriteAccess,
  editingRowId,
  editFormData,
  organisations,
  isAddingRow,
  com_type_is_multi,
  formData,
  com_type_en_name,
  com_type_ar_name,
  setIsLoading,
  setOrganisationCommissionTypes,
  setEditFormData,
  setFormData,
  setCom_type_is_multi,
  setCom_type_ar_name,
  setCom_type_en_name,
  handleEditFormChange,
  handleSaveEditRow,
  handleCancelEditRow,
  handleEditRow,
  handleChange,
  handleAddNewRow,
  handleCancelAddRow,
  handleAddRow,
  remove_organisation_commission_type
}) => {
  const classes = useStyles();
  const currentLanguageCode = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
  const intl = useIntl();
  const history = useHistory();


  return (
    <>  {/* start add commission type section  */}
      {commission_type_id && <div className="Table-Wrapper organizationCommissionTypesTable">
        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: "7px" }}>
            <CircularProgress align="center" style={{ width: "42px" }} />
          </div>
        ) : (
          <Table className={classes.table} size="small" aria-label="organization commission types table">
            <TableHead>
              <TableRow >
                <TableCell align="center" style={{ fontSize: "11px" }} >{intl.formatMessage({ id: 'organization' })}</TableCell>
                <TableCell align="center" style={{ fontSize: "11px" }} >{intl.formatMessage({ id: 'type' })}</TableCell>
                <TableCell align="center" style={{ fontSize: "11px" }} >{intl.formatMessage({ id: 'com_prov' })}</TableCell>
                <TableCell align="center" style={{ fontSize: "11px" }} >{intl.formatMessage({ id: 'com_ret' })}</TableCell>
                <TableCell align="center" style={{ fontSize: "11px" }} >{intl.formatMessage({ id: 'flat_fee' })}</TableCell>
                <TableCell align="center" style={{ fontSize: "11px" }} >{intl.formatMessage({ id: 'vat' })}</TableCell>
                {hasCommissionsWriteAccess && <><TableCell align="center" style={{ fontSize: "11px" }}>
                  {intl.formatMessage({ id: 'actions' })}
                </TableCell></>}
              </TableRow>
            </TableHead>
            <TableBody>
              {organisationCommissionTypes?.length > 0 ?
                organisationCommissionTypes.map((r) => (
                  <TableRow key={r.org_com_id} >
                    {editingRowId === r.org_com_id ? (
                      <>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          <select
                            className="selectStyleTableRowCell"
                            name="ORGANISATION_ID"
                            value={editFormData.ORGANISATION_ID} // Bind to the edit form data
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              setEditFormData((prev) => ({ ...prev, ORGANISATION_ID: selectedId })); // Update the selected organization
                            }}
                            fullWidth
                          >
                            {/* Populate dropdown with filtered organizations */}
                            {organisations
                              .filter(
                                (org) =>
                                  org.id === editFormData.ORGANISATION_ID || // Include the current organization being edited
                                  !organisationCommissionTypes.some((row) => row.org_id === org.id) // Exclude organizations already in the table
                              )
                              .map((org) => (
                                <option key={org.id} value={org.id} className="selectStyleTableRowCell">
                                  {currentLanguageCode === "en-us" ? org.en_name : org.ar_name}
                                </option>
                              ))}
                          </select>
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {currentLanguageCode === "en-us" ? r.com_type_en_name : r.com_type_ar_name}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          <input
                            className="inputStyleTableRowCell"
                            name="COM_PROV"
                            value={editFormData.COM_PROV}
                            onChange={handleEditFormChange}
                            type="number"
                          />{" "}
                          %
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          <input
                            className="inputStyleTableRowCell"
                            name="COM_RET"
                            value={editFormData.COM_RET}
                            onChange={handleEditFormChange}
                            type="number"
                          />{" "}
                          %
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          <input
                            className="inputStyleTableRowCell"
                            name="FLAT_FEE"
                            value={editFormData.FLAT_FEE}
                            onChange={handleEditFormChange}
                            type="number"
                          />{" "}
                          {intl.formatMessage({ id: "currency" })}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          <input
                            className="inputStyleTableRowCell"
                            name="VAT"
                            value={editFormData.VAT}
                            onChange={handleEditFormChange}
                            type="number"
                          />{" "}
                          %
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          <button onClick={(e) => {
                            e.preventDefault(); // Prevent default behavior
                            handleSaveEditRow(); // Call the save handler
                          }}
                            className="buttonStyleTableRowCell">
                            {intl.formatMessage({ id: "save" })}
                          </button><div></div>
                          <button
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default behavior
                              handleCancelEditRow(); // Call the cancel handler
                            }}
                            className="buttonStyleTableRowCell-sec"
                            style={{ marginLeft: "8px" }}
                          >
                            {intl.formatMessage({ id: "cancel" })}
                          </button>
                        </TableCell>
                      </>
                    ) : (
                      <>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {currentLanguageCode === "en-us" ? r.org_en_name : r.org_ar_name}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {currentLanguageCode === "en-us" ? r.com_type_en_name : r.com_type_ar_name}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {parseFloat(r.com_prov) + " %"}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {parseFloat(r.com_ret) + " %"}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {parseFloat(r.flat_fee) + " " + intl.formatMessage({ id: "currency" })}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {parseFloat(r.vat) + " %"}
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "11px" }}>
                          {hasCommissionsWriteAccess && <>
                            <button
                              onClick={(e) => {
                                e.preventDefault(); // Prevent default behavior
                                handleEditRow(r); // Call the edit handler
                              }}
                              className="editAndDeleteIconButton"
                            >
                              <EditIcon style={{ fontSize: "19px" }} className="editAndDeleteIcon" />
                            </button>
                            <>
                              {organisationCommissionTypes?.length > 1 && <button className="delBtn editAndDeleteIcon"
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                                data-bs-toggle="modal" data-bs-target={"#deleteComModal" + r.org_com_id}>
                                <DeleteIcon style={{ fontSize: "19px" }} />
                              </button>}
                              <div className="modal fade" style={{ zIndex: "9999969" }} id={"deleteComModal" + r.org_com_id} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                  <div className="modal-content">
                                    <div className="modal-header">

                                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body" style={{ wordWrap: "break-word" }}>
                                      <h6>  {currentLanguageCode == "en-us" ? `Are You Sure You Want To Delete` : `هل أنت متأكد انك تريد حذف`}</h6>
                                      <h6 style={{ fontWeight: "bold" }}>  {currentLanguageCode == "en-us" ? `${r.org_en_name + " - " + r.com_type_en_name} Commission` : ` عمولة ${r.org_ar_name + " - " + r.com_type_ar_name}`}</h6>

                                    </div>
                                    <div className="modal-footer" style={{ direction: currentLanguageCode == "en-us" ? "ltr" : "rtl" }}>
                                      <button type="button" className="btn btn-outline-dark"
                                        onClick={
                                          (e) => {
                                            e.preventDefault();
                                          }
                                        } data-bs-dismiss="modal">{intl.formatMessage({ id: 'Cancel' })} </button>
                                      <button type="button"
                                        className="btn btn-danger" data-bs-dismiss="modal"

                                        onClick={
                                          (e) => {
                                            e.preventDefault(); // Prevent default behavior
                                            remove_organisation_commission_type(r.org_com_id)
                                          }
                                        }>{intl.formatMessage({ id: 'Delete' })} </button>

                                    </div>
                                  </div>
                                </div>
                              </div></></>}
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                )) : <tr> <td colSpan={6} style={{ textAlign: "center", padding: "15px" }}>{intl.formatMessage({ id: 'NoDateAvailable' })}</td></tr>}
              {isAddingRow && com_type_is_multi && organisations
                .filter((org) => {
                  const isExcluded = organisationCommissionTypes.some(
                    (row) => String(row.org_id) === String(org.id)
                  );

                  return !isExcluded;
                }).length > 0 && (
                  <TableRow>
                    <TableCell align="center" style={{ fontSize: "11px" }} >
                      <select
                        className="selectStyleTableRowCell"
                        name="ORGANISATION_ID"
                        value={formData.ORGANISATION_ID}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          setFormData((prev) => ({ ...prev, ORGANISATION_ID: selectedId }));
                        }}
                        fullWidth
                      >
                        <option value="" disabled style={{ fontWeight: "bold" }}>{intl.formatMessage({ id: 'Select_Organization' })}</option>
                        {organisations
                          .filter((org) => {
                            const isExcluded = organisationCommissionTypes.some(
                              (row) => String(row.org_id) === String(org.id)
                            );

                            return !isExcluded;
                          })
                          .map((org) => (
                            <option key={org.id} value={org.id} className="selectStyleTableRowCell">
                              {currentLanguageCode === "en-us" ? org.en_name : org.ar_name}
                            </option>
                          ))}
                      </select>
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "11px" }} >
                      {currentLanguageCode === "en-us" ? com_type_en_name : com_type_ar_name}

                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "11px" }} >
                      <input
                        className='inputStyleTableRowCell'
                        name="COM_PROV"
                        value={formData.COM_PROV}
                        onChange={handleChange}
                        fullWidth
                        min="1"
                        type='number'
                      /> %
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "11px" }} >
                      <input
                        className='inputStyleTableRowCell'
                        name="COM_RET"
                        value={formData.COM_RET}
                        onChange={handleChange}
                        fullWidth
                        min="1"
                        type='number'
                      /> %
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "11px" }} >
                      <input
                        name="FLAT_FEE"
                        value={formData.FLAT_FEE}
                        className='inputStyleTableRowCell'
                        onChange={handleChange}
                        fullWidth
                        min="1"
                        type='number'
                      />  {intl.formatMessage({ id: 'currency' })}
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "11px" }} >
                      <input
                        className='inputStyleTableRowCell'
                        name="VAT"
                        value={formData.VAT}
                        onChange={handleChange}
                        fullWidth
                        min="1"
                        type="number"
                      /> %
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "11px", border: "2px solid #EFEFEF" }} >
                      <button onClick={handleAddNewRow} className='buttonStyleTableRowCell'>
                        {intl.formatMessage({ id: 'save' })}
                      </button>  <div></div>
                      <button onClick={handleCancelAddRow} className='buttonStyleTableRowCell-sec ' >
                        {intl.formatMessage({ id: 'cancel' })}
                      </button>
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        )}
        {!isAddingRow && com_type_is_multi && organisations
          .filter((org) => {
            const isExcluded = organisationCommissionTypes.some(
              (row) => String(row.org_id) === String(org.id)
            );

            return !isExcluded;
          }).length > 0 && (
            <button onClick={handleAddRow} className='buttonStyleTableRowCellAdd'>
              {intl.formatMessage({ id: '+' })}
            </button>
          )}
      </div>}
      {/* end add commission type section  */}
      <ToastContainer />
    </>
  );
};

export default OrgComTypTable;

